/** LAND5: scene copy, fictional demonstration records, geometry and timings. */
export const LANDING_MOTION = Object.freeze({
  navHeight: 72, compactMax: 640, visibleRatio: 0.6, skipAt: 0.86,
  flightMs: 1100, peckMs: 420, circleMs: 900, logoMs: 2400, presentMs: 4500, installMs: 1600,
  revealMs: 2600, cleanMs: 650, calmMs: 1100, toolMs: 1050, storyBeatMs: 4000,
  heroSurpriseMs: 3000, heroIdleMs: 9000, simIdleMs: 8000,
  magicMs: 1400, paymentIntroMs: 1600, paymentActionMs: 1800,
  crossFlightMs: 370, crossPeckMs: 140, crossCleanMs: 220,
});

export const LANDING_PAYMENT_ACTIONS = Object.freeze([
  { key: 'remind-one', selector: '.ppl__row .ppl__btn--relance', explanation: 'Relance une famille.' },
  { key: 'pay', selector: '.ppl__row .ppl__btn--pay', explanation: 'Ou enregistre un paiement reçu.' },
  { key: 'remind-all', selector: '.ppl__bulk-btn', explanation: 'Et relance toutes les familles en une fois !' },
]);

export const LANDING_SCENE_COPY = Object.freeze({
  heroLines: ['Tu doubles tes gains.', 'Ton élève paie pareil.', 'NeoProf range tout.'],
  chartLabel: 'Chiffre d’affaires', chartAlt: 'Janvier et février sans NeoProf, puis une hausse en mars et avril avec NeoProf.',
  months: ['Janvier', 'Février', 'Mars', 'Avril'],
  withNeo: 'Avec NeoProf',
  idle: 'Tu veux simuler tes gains ou essayer gratuitement ?',
  try: 'Essayer gratuitement', simulate: 'Simuler mes gains', close: 'Fermer',
  stormLead: 'Une seule fenêtre, un seul réflexe.',
  happyAlt: 'La même enseignante, sereine, un café à la main, NeoProf à l’écran.',
  dashboardAlt: 'Le tableau de bord NeoProf sur le moniteur : paiements en attente et prochains cours.',
  slogan: 'Dis adieu aux heures de travail inutile.', sloganSub: 'NeoProf automatise tout.',
  payments: { title: 'Tes paiements, sous les yeux.', explanation: 'Repère qui te doit quoi et ce qu’il reste à encaisser.', widgetTitle: 'Paiements en attente', total: '240 €' },
  lessons: { title: 'Ta prochaine séance est déjà là.', explanation: 'L’élève, l’horaire, la matière. Tu sais ce qui t’attend.', widgetTitle: 'Aujourd’hui' },
  demoLabel: 'Exemple de tableau de bord',
  founderEyebrow: 'Conçu par un prof, pour les profs',
  story: [
    'Pendant six ans, les soirées de Mahmoud appartenaient à Excel.',
    'Les factures. Les déclarations. L’Avance Immédiate à poser, famille après famille.',
    'Un soir, il a refermé le tableur. Et il a construit l’outil qu’il aurait voulu avoir.',
    'L’Avance Immédiate posée. Les factures écrites. Les déclarations prêtes.',
    'Ses soirées lui sont revenues.',
  ],
  founderClimax: 'Son chiffre d’affaires a plus que doublé grâce à NeoProf.',
  storyPrev: 'Phrase précédente', storyNext: 'Phrase suivante',
  simTitle: 'Mais comment je double mes gains ?',
  simQuestions: { rate: 'Quel est ton prix horaire ?', hours: 'Combien d’heures de cours par semaine ?', admin: 'Combien d’heures d’administratif par semaine ?' },
  less: 'Moins', more: 'Plus', simGuide: 'Clique sur Suivant quand c’est bon.',
  familyPending: 'À régler · 80 €', familyPay: 'Payer', familyPaid: 'Paiement reçu', familyDemo: 'Démonstration du paiement',
});

export const LANDING_DEMO_PAYMENTS = Object.freeze([
  { family_id: 'land5-dupont', family_name: 'Jean Dupont', unpaid_lessons: 3, total_due: 120 },
  { family_id: 'land5-martin', family_name: 'Marie Martin', unpaid_lessons: 2, total_due: 80 },
  { family_id: 'land5-bernard', family_name: 'Pierre Bernard', unpaid_lessons: 1, total_due: 40 },
]);
export const LANDING_DEMO_TODAY = Object.freeze({
  sessions: [], suggested: [], scheduled: [
    { student_id: 'land5-lucas', first_name: 'Lucas', last_name: 'Dupont', time: '09:00', duration_hours: 1, subject: 'Mathématiques', class_level: '2nde' },
    { student_id: 'land5-emma', first_name: 'Emma', last_name: 'Martin', time: '11:00', duration_hours: 1, subject: 'Mathématiques', class_level: '3eme' },
    { student_id: 'land5-hugo', first_name: 'Hugo', last_name: 'Bernard', time: '14:00', duration_hours: 1, subject: 'Physique', class_level: '1ere' },
  ],
});
export const LANDING_STORM_TOOLS = Object.freeze([
  { icon: 'excel', name: 'Excel', at: [55, 30], tall: [56, 36] },
  { icon: 'agenda', name: 'Google Agenda', at: [68, 25], tall: [82, 33] },
  { icon: 'gmail', name: 'Gmail', at: [64, 45], tall: [70, 47] },
  { icon: 'drive', name: 'Drive', at: [52, 17], tall: [52, 28] },
  { icon: 'acrobat', name: 'Acrobat', at: [86, 48], tall: [88, 60] },
  { icon: 'word', name: 'Word', at: [80, 60], tall: [82, 71] },
  { icon: 'whatsapp', name: 'WhatsApp', at: [55, 74], tall: [33, 80] },
  { icon: 'notes', name: 'Notes', at: [93, 82], tall: [72, 91] },
  { icon: 'classroom', name: 'Google Classroom', at: [30, 88], tall: [18, 90] },
  { icon: 'kartable', name: 'Kartable', at: [46, 92], tall: [42, 94] },
]);
export const LANDING_SCREEN = Object.freeze({
  wide: [[48.03, 17.75], [76.5, 14.03], [74.94, 58.34], [46.95, 49.1]],
  tall: [[53.35, 23.4], [100, 23.4], [100, 53.2], [50.6, 46.1]],
  payments: { wide: [[64.4, 26.5], [75.6, 25.5], [75.1, 41.5], [64, 40.5]], tall: [[86, 30.5], [100, 30.7], [100, 41.5], [85.5, 40.7]] },
  lessons: { wide: [[49.7, 36], [64, 37.3], [63.5, 52.5], [49.4, 49.6]], tall: [[57.2, 37], [85, 37.7], [84, 50.5], [57, 47.3]] },
});
